import { render, staticRenderFns } from "./lista-inicio.vue?vue&type=template&id=15a846d8&scoped=true&"
import script from "./lista-inicio.vue?vue&type=script&lang=ts&"
export * from "./lista-inicio.vue?vue&type=script&lang=ts&"
import style0 from "./lista-inicio.vue?vue&type=style&index=0&id=15a846d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a846d8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAlert,VIcon})
